import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const BankGuaranteeInformationContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})

export const TypeOfBondContent = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  fontSize: '1.25rem',
  fontWeight: 'bold',
  marginTop: '10px'
})
